import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section-header" }
const _hoisted_2 = { class: "section-header" }

import { IonButton, IonCard, IonCardContent, IonChip, IonIcon, IonSelect, IonSelectOption, IonItem, IonLabel, modalController } from '@ionic/vue';
import { addCircleOutline, closeCircle } from 'ionicons/icons'
import { translate } from '@hotwax/dxp-components';
import AddProductFiltersModal from '@/components/AddProductFiltersModal.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductFilters',
  setup(__props) {

const store = useStore();

const appliedFilters = computed(() => store.getters["util/getAppliedFilters"]);
const appliedFiltersOperator = computed(() => store.getters["util/getAppliedFiltersOperator"]);

const conditionAppliedFiltersOperator = JSON.parse(JSON.stringify(appliedFiltersOperator.value))

async function openProductFilterModal(label: string, facetToSelect: string, searchfield: string, type: string) {
  const modal = await modalController.create({
    component: AddProductFiltersModal,
    componentProps: {
      label,
      facetToSelect,
      searchfield,
      type
    },
  })

  modal.present()
}

async function removeFilters(type: string, id: string, value: string) {
  const selectedFilters = JSON.parse(JSON.stringify(appliedFilters.value))
  selectedFilters[type][id] = selectedFilters[type][id].filter((filter: any) => filter !== value)

  await store.dispatch('util/updateAppliedFilters', selectedFilters)
}

async function updateFiltersOperator(type: string, id: string, value: string) {
  conditionAppliedFiltersOperator[type][id] = value
  await store.dispatch('util/updateAppliedFiltersOperator', conditionAppliedFiltersOperator)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_unref(translate)("Products by tags")), 1)
    ]),
    _createElementVNode("section", null, [
      _createVNode(_unref(IonCard), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonItem), { lines: "full" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Included")), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonButton), {
                fill: "clear",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openProductFilterModal('tags', 'tagsFacet', 'tags', 'included')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Add")) + " ", 1),
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(addCircleOutline),
                    slot: "end"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), { lines: "none" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSelect), {
                interface: "popover",
                label: "Operator",
                value: _unref(conditionAppliedFiltersOperator)['included']['tags'] || 'or',
                onIonChange: _cache[1] || (_cache[1] = ($event: any) => (updateFiltersOperator('included', 'tags', $event.detail.value)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSelectOption), { value: "and" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("AND")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), { value: "or" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("OR")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCardContent), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appliedFilters.value['included']['tags'], (tag, index) => {
                return (_openBlock(), _createBlock(_unref(IonChip), {
                  outline: "",
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tag) + " ", 1),
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(closeCircle),
                      onClick: ($event: any) => (removeFilters('included', 'tags', tag))
                    }, null, 8, ["icon", "onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonCard), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonItem), { lines: "full" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Excluded")), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonButton), {
                fill: "clear",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (openProductFilterModal('tags', 'tagsFacet', 'tags', 'excluded')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Add")) + " ", 1),
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(addCircleOutline),
                    slot: "end"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), { lines: "none" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSelect), {
                interface: "popover",
                label: "Operator",
                value: _unref(conditionAppliedFiltersOperator)['excluded']['tags'] || 'and',
                onIonChange: _cache[3] || (_cache[3] = ($event: any) => (updateFiltersOperator('excluded', 'tags', $event.detail.value)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSelectOption), { value: "and" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("AND")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), { value: "or" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("OR")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCardContent), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appliedFilters.value['excluded']['tags'], (tag, index) => {
                return (_openBlock(), _createBlock(_unref(IonChip), {
                  outline: "",
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tag) + " ", 1),
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(closeCircle),
                      onClick: ($event: any) => (removeFilters('excluded', 'tags', tag))
                    }, null, 8, ["icon", "onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_unref(translate)("Products by feature")), 1)
    ]),
    _createElementVNode("section", null, [
      _createVNode(_unref(IonCard), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonItem), { lines: "full" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Included")), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonButton), {
                fill: "clear",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (openProductFilterModal('product features', 'productFeaturesFacet', 'productFeatures', 'included')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Add")) + " ", 1),
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(addCircleOutline),
                    slot: "end"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), { lines: "none" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSelect), {
                interface: "popover",
                label: "Operator",
                value: _unref(conditionAppliedFiltersOperator)['included']['productFeatures'] || 'or',
                onIonChange: _cache[5] || (_cache[5] = ($event: any) => (updateFiltersOperator('included', 'productFeatures', $event.detail.value)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSelectOption), { value: "and" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("AND")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), { value: "or" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("OR")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCardContent), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appliedFilters.value['included']['productFeatures'], (feature, index) => {
                return (_openBlock(), _createBlock(_unref(IonChip), {
                  outline: "",
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(feature) + " ", 1),
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(closeCircle),
                      onClick: ($event: any) => (removeFilters('included', 'productFeatures', feature))
                    }, null, 8, ["icon", "onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonCard), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonItem), { lines: "full" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonLabel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Excluded")), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonButton), {
                fill: "clear",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (openProductFilterModal('product features', 'productFeaturesFacet', 'productFeatures', 'excluded')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Add")) + " ", 1),
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(addCircleOutline),
                    slot: "end"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonItem), { lines: "none" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSelect), {
                interface: "popover",
                label: "Operator",
                value: _unref(conditionAppliedFiltersOperator)['excluded']['productFeatures'] || 'and',
                onIonChange: _cache[7] || (_cache[7] = ($event: any) => (updateFiltersOperator('excluded', 'productFeatures', $event.detail.value)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSelectOption), { value: "and" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("AND")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSelectOption), { value: "or" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("OR")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCardContent), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appliedFilters.value['excluded']['productFeatures'], (feature, index) => {
                return (_openBlock(), _createBlock(_unref(IonChip), {
                  outline: "",
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(feature) + " ", 1),
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(closeCircle),
                      onClick: ($event: any) => (removeFilters('excluded', 'productFeatures', feature))
                    }, null, 8, ["icon", "onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})